"use strict";

const debounce = require("lodash/debounce");

/**
 * Method to get product thumbnails constants
 * @returns {object}
 */
const getProductThumbnailsConstants = () => {
    const { xl } = require("../breakpoints").globalBreakpoints;
    const thumbnailsInitLimit = 6;
    const mainImageSliderSelector = ".pdp-slider";
    const carouselOptions = {
        infinite: false,
        slidesToScroll: 1,
        swipeToSlide: true,
        dots: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        prevArrow: ".thumb-prev-btn",
        nextArrow: ".thumb-next-btn",
        slidesToShow: 5.45,
        responsive: [
            {
                breakpoint: xl,
                settings: {
                    slidesToShow: thumbnailsInitLimit - 2,
                },
            },
        ],
    };

    return {
        thumbnailsIncludedClassName: "thumbnails-included",
        selectedClassName: "selected",
        thumbnailsContainerSelector: ".product-thumbnails-container",
        thumbnailsWrapperSelector: ".product-thumbnails-list",
        thumbnailElementSelector: ".product-thumbnail-item",
        thumbnailsCountAttrName: "data-thumbnails-count",
        thumbnailImageIndexAttrName: "data-thumbnail-index",
        mainImageSliderSelector: mainImageSliderSelector,
        thumbnailsInitLimit: thumbnailsInitLimit,
        carouselOptions: carouselOptions,
    };
};

/**
 * Handle change slide
 * @param {HTMLElement} thumbnailEl
 * @returns {void}
 */
const handleChangeSlide = (thumbnailEl) => {
    if (!thumbnailEl) return;

    const { selectedClassName, thumbnailElementSelector } = getProductThumbnailsConstants();
    const previouslySelected = document.querySelector(`${thumbnailElementSelector}.selected`);

    if (previouslySelected) {
        previouslySelected.classList.remove(selectedClassName);
    }

    thumbnailEl.classList.add(selectedClassName);
};

/**
 * Handle thumbnails events listeners
 * @param {boolean} isReinit
 * @returns {void}
 */
const handleThumbnailsEvents = (isReinit) => {
    if (isReinit) return;

    const {
        thumbnailsWrapperSelector,
        thumbnailImageIndexAttrName,
        thumbnailsContainerSelector,
        thumbnailElementSelector,
        mainImageSliderSelector,
        thumbnailsIncludedClassName,
    } = getProductThumbnailsConstants();
    const thumbnailsContainer = document.querySelector(thumbnailsContainerSelector);
    const thumbnailsWrapper = thumbnailsContainer?.querySelector(`:scope ${thumbnailsWrapperSelector}`);
    const productImagesContainer = thumbnailsContainer?.closest(".primary-images");
    const $mainImageSlider = $(`${mainImageSliderSelector}.slick-initialized`);

    $(window).on(
        "resize",
        debounce(() => {
            productImagesContainer.classList.remove(thumbnailsIncludedClassName);

            // re-initialize the thumbnails functionality
            initProductThumbnails(true);
        }, 500)
    );

    if (!$mainImageSlider.length) return;

    $mainImageSlider.on("afterChange", (event, slick, currentSlide) => {
        const indexToSelect = currentSlide;
        const thumbnailEl = thumbnailsWrapper?.querySelector(
            `:scope ${thumbnailElementSelector}[${thumbnailImageIndexAttrName}="${indexToSelect}"]`
        );
        handleChangeSlide(thumbnailEl);
    });
};

/**
 * Handle unslick
 * @param {HTMLElement} container
 * @returns {void}
 */
const handleUnslick = (container) => {
    if (!container) return;

    if (container.classList.contains("slick-initialized")) {
        $(container).slick("unslick");
    }
};

/**
 * Handle thumbnails carousel
 * @param {HTMLElement} thumbnailsWrapper
 * @returns {void}
 */
const handleThumbnailsCarousel = (thumbnailsWrapper) => {
    if (!thumbnailsWrapper) return;

    handleUnslick(thumbnailsWrapper);

    const { carouselOptions, thumbnailsIncludedClassName} =
        getProductThumbnailsConstants();

    const productImagesContainer = thumbnailsWrapper.closest(".primary-images");

    productImagesContainer.classList.add(thumbnailsIncludedClassName);
    $(thumbnailsWrapper).slick(carouselOptions);
};

/**
 * Handle product thumbnails
 * @param {HTMLElement} thumbnailsWrapper
 * @returns {void}
 */
const handleProductThumbnails = (thumbnailsWrapper) => {
    if (!thumbnailsWrapper) return;

    const { thumbnailElementSelector, thumbnailImageIndexAttrName, mainImageSliderSelector } =
        getProductThumbnailsConstants();

    $(thumbnailElementSelector)
        .off("click")
        .on("click", (event) => {
            const thumbnailEl = event.currentTarget;
            const imageListIndex =
                thumbnailEl?.hasAttribute(thumbnailImageIndexAttrName) &&
                thumbnailEl?.getAttribute(thumbnailImageIndexAttrName);
            const mainImagesSlider = document.querySelector(mainImageSliderSelector);

            if (!mainImagesSlider) return;

            handleChangeSlide(thumbnailEl);
            $(mainImagesSlider).slick("slickGoTo", parseInt(imageListIndex, 10));
        });
};

const handleThumbnailClick = () => {
    const { thumbnailElementSelector, mainImageSliderSelector, thumbnailImageIndexAttrName } = getProductThumbnailsConstants();
    $(thumbnailElementSelector).first().addClass("active-slide");

    $(thumbnailElementSelector).off("click").on("click", (event) => {
        $(thumbnailElementSelector).removeClass("active-slide");
        const thumbnailEl = event.currentTarget;
        const imageListIndex =
            thumbnailEl?.hasAttribute(thumbnailImageIndexAttrName) &&
            thumbnailEl?.getAttribute(thumbnailImageIndexAttrName);

        thumbnailEl.classList.add("active-slide");
        $(mainImageSliderSelector).slick("slickGoTo", parseInt(imageListIndex, 10));
    });
};


/**
 * Init product thumbnails
 * @param {boolean} isReinit - boolean to be passed for re-initialization, in order to avoid attaching the event listeners on resize event
 * @returns {void}
 */
const initProductThumbnails = (isReinit) => {
    const {
        thumbnailsInitLimit,
        thumbnailsIncludedClassName,
        thumbnailsWrapperSelector,
        thumbnailsCountAttrName,
        thumbnailsContainerSelector,
    } = getProductThumbnailsConstants();
    const thumbnailsWrapper = document.querySelector(thumbnailsWrapperSelector);
    const thumbnailsCount =
        thumbnailsWrapper?.hasAttribute(thumbnailsCountAttrName) &&
        parseInt(thumbnailsWrapper?.getAttribute(thumbnailsCountAttrName), 10);
    const productImagesContainer = thumbnailsWrapper?.closest(".primary-images");
    const thumbnailsContainer = thumbnailsWrapper?.closest(thumbnailsContainerSelector);
    const hasVisibleThumbnails = thumbnailsContainer && $(thumbnailsContainer).css("display") === "block";

    if (!thumbnailsWrapper) return;

    if (isReinit) {
        handleUnslick(thumbnailsWrapper);
    }

    if (!thumbnailsCount || !hasVisibleThumbnails) return;

    // add class name to indicate the thumbnails being present on the page
    if (thumbnailsCount === 1) {
        productImagesContainer.classList.add(thumbnailsIncludedClassName);
        return;
    }

    productImagesContainer.classList.add(thumbnailsIncludedClassName);
    handleThumbnailClick();

    if (thumbnailsCount < thumbnailsInitLimit) {
        // if the thumbnails count is less than the init limit, then we don't need to initialize the carousel
        // instead, we'll just handle the click event on the thumbnails
        handleProductThumbnails(thumbnailsWrapper);
        handleThumbnailsEvents(isReinit);
        return;
    }

    // if the thumbnails count is greater than the init limit, then we'll initialize the carousel
    handleThumbnailsCarousel(thumbnailsWrapper);
    handleThumbnailsEvents(isReinit);
};

module.exports = {
    initProductThumbnails: initProductThumbnails,
};
